<template>
  <header class="site_header">
    <div class="site_header__logo_wrapper" v-on:click="gotoHome()">
      <img class="site_header__logo" src="@/assets/hlogo.svg" />
    </div>
  </header>
</template>

<script>
export default {
  name: "ContentsHeader",
  methods: {
    gotoHome() {
      this.$router.push("/");
    },
  },
  props: {},
};
</script>
